import { Component, EventEmitter, Output } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-splash',
  standalone: true,
  imports: [NgIf],
  templateUrl: './splash.component.html',
  styleUrl: './splash.component.css'
})
export class SplashComponent {
  showLegends = false;
  showNever = false;
  showLayup = false;

  combined = false;
  finished = false;

  @Output() done = new EventEmitter<void>();

  ngOnInit() {
    setTimeout(() => this.showLegends = true, 600);
    setTimeout(() => this.showNever = true, 1700);
    setTimeout(() => this.showLayup = true, 2900);

    // 500ms after Layup appears
    setTimeout(() => this.combineWords(), 2400);
  }

  combineWords() {
    //this.combined = true;

    // allow animation to complete before removing splash
    setTimeout(() => {
      this.finished = true;
      this.done.emit();
    }, 1200);
  }
}
